export const VITO_APP_ID = "vitotechnologysite";
export const COMPANY_NAME = "Vito Technology";
export const COMPANY_FULL_NAME = "Vito Technology, Inc.";
